import { DomEditor } from '@wangeditor/editor';

const withMention = (editor) => {
  const { insertText, isInline, isVoid } = editor;
  // 重写 insertText
  editor.insertText = (t) => {
    // 选过选中了 void 元素
    const elems = DomEditor.getSelectedElems(editor);
    const isSelectedVoidElem = elems.some(function (elem) {
      return editor.isVoid(elem);
    });
    if (isSelectedVoidElem) {
      insertText(t);
      return;
    }

    insertText(t);
  };

  // 重写 isInline
  editor.isInline = (elem) => {
    const type = DomEditor.getNodeType(elem);
    if (type === 'mention') return true;
    return isInline(elem);
  };

  // 重写 isVoid
  editor.isVoid = (elem) => {
    const type = DomEditor.getNodeType(elem);
    if (type === 'mention') return true;
    return isVoid(elem);
  };

  return editor;
};

export default withMention;
